import $ from 'jquery';

export const burgerToggle = {
    burgerToggle: document.querySelector('.burger__item'),
    burgerParent: 'burger',
    bodyOverflow: document.querySelector('body'),
    menu: document.querySelector('.header__content'),
    header: document.querySelector('.header'),
    banner: document.querySelector('.home-intro'),

    event() {
        const self = this;
        let opened = false;

        

        this.burgerToggle.addEventListener('click', function(){
            const {
                scrollY
            } = window;
            opened = !opened;
            if($(".b24-widget-button-wrapper").length != 0)
            {
                if(opened)
                    $(".b24-widget-button-wrapper").removeClass("b24-widget-button-visible");
                else if(!$(".smart-panel").hasClass("active")) $(".b24-widget-button-wrapper").addClass("b24-widget-button-visible");
            }
            this.classList.toggle('open');
            this.closest(`.${self.burgerParent}`).classList.toggle('open');
            self.bodyOverflow.classList.toggle('overflow');
            self.menu.classList.toggle('open');
            if(opened)
            {
                self.bodyOverflow.classList.add('overflow');
                self.header.classList.remove('color');
            }
            else {
                if($(".home-intro").height() > scrollY)
                    self.header.classList.add('color');
                self.bodyOverflow.classList.remove('overflow');
            }

            
            self.header.classList.toggle('open-header');
        })
    },

    init() {
        this.event()
    }
}


// WEBPACK FOOTER //
// app/scripts/components/burger.js